import { getAsyncV2, post, postAsync, postAsyncV2 } from "./apiManager";

export const placeAppointment = (body, onSuccess, onFailed, onComplete) => {
  post(
    "Appointment",
    body,
    "placeAppointment",
    onSuccess,
    onFailed,
    onComplete
  );
};

export const makeOnlineAppointment = async (requestBody) => {
  const response = await postAsyncV2(
    "appointments/make-online-appointment",
    requestBody
  );
  const data = await response.json();
  return data?.data;
};

export const getAppointments = (
  PatientMobile,
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  fetch(
    `${process.env.REACT_APP_MEDICA_URL}AppointmentPrescriptionRecord/GetAppointment`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        UserId: 2,
      },
      body: JSON.stringify({
        PatientMobile,
      }),
    }
  )
    .then((res) => res.json())
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onFailed(error);
    })
    .finally(() => {
      onComplete();
    });
};

export const getAppointmentV2 = async (requestBody) => {
  const response = await postAsyncV2("appointments/get", requestBody);
  const data = await response.json();
  return data?.data;
};

export const getBillData = async ({ appointmentId }) => {
  const response = await getAsyncV2(`bill/get?appointmentId=${appointmentId}`)
  const data = await response.json();
  return data?.data;
};
